//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.12.2016.
 */

(function () {

    'use strict';

    const MegaTableColumnKey = {
        ROW_OVERLAY: '__mt_rowOverlay__',
        SELECT: '__mt_select__',
        ACTION: '__mt_action__'
    };

    const MegaTableItemProperty = {
        SELECTED: '__mt_selected__',
        HIDDEN: '__mt_hidden__'
    };

    angular.module('container.widgets')
        .constant('MegaTableColumnKey', MegaTableColumnKey)
        .constant('MegaTableItemProperty', MegaTableItemProperty);
})();